import { render, staticRenderFns } from "./BonusCorrectionDiscrepancy.vue?vue&type=template&id=7986e888&"
import script from "./BonusCorrectionDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./BonusCorrectionDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports